export type PlanDimDraftSelections = Record<string, string[]>;

export const selectionsFromRedux = (selectedBlockDimension: any[]): PlanDimDraftSelections => {
  const draft: PlanDimDraftSelections = {};
  (selectedBlockDimension ?? []).forEach((entry) => {
    const dimensionName = Object.keys(entry ?? {})[0];
    if (!dimensionName) return;
    draft[dimensionName] = Array.isArray(entry[dimensionName]) ? [...entry[dimensionName]] : [];
  });
  return draft;
};

export const selectionsToRedux = (draft: PlanDimDraftSelections) =>
  Object.entries(draft).map(([name, items]) => ({ [name]: items }));

export const buildDefaultDraft = (
  dimensions: Array<{ name: string; items: string[] }>,
): PlanDimDraftSelections => {
  const draft: PlanDimDraftSelections = {};
  dimensions.forEach((dimension) => {
    draft[dimension.name] = [...(dimension.items ?? [])];
  });
  return draft;
};

export const countActiveFilterItems = (source: any[]) =>
  (source ?? []).reduce((count: number, item: any) => {
    const values = Object.values(item ?? {})[0];
    return count + (Array.isArray(values) ? values.length : 0);
  }, 0);
